import { EMPTY_CHAT } from "../../../const/typeDefault/Chat";
import { useChat } from "../../../fetch/fetch.chat";
import { ReactNode } from "react";
import { useChatController } from "../../../hooks/useChatController";
import ErrMessage from "../../core/ErrMessage";

const ChatValid = ({
  chatId,
  children,
  loading,
  fallback,
}: {
  chatId: string;
  children: ReactNode;
  loading: ReactNode;
  fallback: ReactNode;
}) => {
  const { chat, isLoading, isError } = useChat(chatId, EMPTY_CHAT);
  const { chatIsValid } = useChatController();

  if (isError) return <ErrMessage message={isError.message} />;
  if (isLoading) return loading;
  if (!chatIsValid(chat)) return fallback;
  return children;
};
export default ChatValid;
